import { imageBase64 } from './ImageStore';

export const updateImageBase64 = (value) => imageBase64.update((oldValue) => value);
